import React from 'react'
import { Redirect, useHistory, withRouter } from 'react-router-dom'

import { connect } from 'react-redux'
import { Button, Input, Section } from '../../components'
import { ActivateStyled } from './styled'
import { authController } from '../../apiService'
import { STRING, ROUTE_PATH, localStorageService } from '../../helpers'
import { toast } from 'react-toastify'
import { Formik, Form } from 'formik'
import * as yup from 'yup'
import { controller } from '../../middleware'

class ActivateContainer extends React.Component {
  constructor(props) {
    super(props)

    this.onFormSubmit = this.onFormSubmit.bind(this)
    this.state = {
      formDetail: {
        password: '',
        confirmPassword: '',
        isError: false,
        errorMessage: '',
        passwordCorrect: false,
        confirmPasswordCorrect: false,
        confrimPasswordMatch: false,
      },
      isRedirect: false,
    }
  }

  componentDidMount() {
    this.getToken()
  }

  getToken = () => {
    const { params } = this.props.match
    if (params) {
      if (params.token) {
        const token = params.token
        this.checkTokenExp(token)
      } else {
        console.log('Token not found')
      }
    }
  }

  checkTokenExp = async (token = '') => {
    try {
      const res = await authController().checkTokenExp(token)
      if (res && res.status === 'TokenValid') {
        return
      } else if (res.status === 'Invalid') {
        throw res
      } else if (res.status === 'Already Account') {
        setTimeout(
          this.props.history.push(ROUTE_PATH.LINK_HAVE_ACCOUNT.LINK),
          500
        )
      } else if (res.response && res.response.status) {
        if (res.response.status === 400) {
          // this.goToLinkTokenExpPage()
          this.setState({ isRedirect: true })
        } else if (res.response.status === 401) {
          throw res
        }
      } else {
        console.log('checkTokenExp fail')
      }
    } catch (error) {
      console.log('errror', error)
      if (error.response && error.response.status) {
        if (error.response.status === 400) {
          this.setState({ isRedirect: true })
        } else if (error.response.status === 401) {
          return controller().redirectToLogin()
        }
      }
      throw error
    }
  }

  goToLinkTokenExpPage = () => {
    this.props.history.replace(ROUTE_PATH.LINK_TOKEN_EXPIRED.LINK)
  }

  handleUserInput = (formikHandle = () => {}, e, setFieldError = () => {}) => {
    const { name, value } = e.target
    this.validValueMin(name, value, setFieldError)
    formikHandle(name, value.trim())
  }

  checkMinlenght = (value = '') => {
    const minLength = 8
    return value.length >= minLength
  }

  validValueMin = (fieldName, value, setFieldError) => {
    let passwordCorrect = this.state.passwordCorrect
    let confirmPasswordCorrect = this.state.confirmPasswordCorrect
    let confrimPasswordMatch = this.state.formDetail.confrimPasswordMatch
    switch (fieldName) {
      case 'password':
        passwordCorrect = this.checkMinlenght(value)
        break
      case 'confirmPassword':
        confirmPasswordCorrect = this.checkMinlenght(value)
        confrimPasswordMatch = this.state.formDetail.password === value
        break
      default:
        break
    }
    this.setState({
      passwordCorrect,
      confirmPasswordCorrect,
      confrimPasswordMatch,
    })
    // if (!confrimPasswordMatch) {
    //   setErrors({ confirmPassword: 'Password does not match' })
    // }
  }

  valideWhiteSpace = (str = '') => {
    return /^(.*\s+.*)+$/.test(str)
  }

  findCountWhiteSpace = (str = '') => {
    return str.split(' ').length - 1
  }

  validCountWhiteSpace = (str = '', actions = () => {}) => {
    if (this.findCountWhiteSpace(str) >= 8) {
      actions.setErrors({
        confirmPassword: 'This field is required',
        password: 'This field is required',
      })
      return true
    } else if (
      this.findCountWhiteSpace(str) < 8 &&
      this.findCountWhiteSpace(str) > 0
    ) {
      actions.setErrors({
        confirmPassword: 'minimum 8 characters',
        password: 'minimum 8 characters',
      })
      return true
    } else {
      return false
    }
  }

  onFormSubmit = async (values, actions) => {
    const passWordHaveWhiteSpace =
      this.validCountWhiteSpace(values.password, actions) &&
      this.validCountWhiteSpace(values.confirmPassword, actions)
    const passwordNotMatchAndNotWhiteSpace =
      !this.valideWhiteSpace(values.password) &&
      !this.valideWhiteSpace(values.confirmPassword) &&
      values.password !== values.confirmPassword
    if (passWordHaveWhiteSpace) {
      return
    } else if (passwordNotMatchAndNotWhiteSpace) {
      actions.setErrors({
        confirmPassword: 'Password does not match',
      })
    } else {
      try {
        const res = await authController().setupPassword({
          mail_key: this.props.match.params.token,
          password: values.password.trim(),
        })
        if (res) {
          toast.success('Activation completed')
          this.gotoLogin()
          setTimeout(() => actions.resetForm(), 3100)
        }
      } catch (error) {
        throw new Error(error)
      }
    }
  }

  gotoLogin = () => {
    setTimeout(() => {
      this.props.history.push(ROUTE_PATH.LOGIN.LINK)
    }, 3000)
  }

  componentWillUnmount() {
    clearTimeout()
  }

  render() {
    const { isRedirect } = this.state
    return (
      <React.Fragment>
        {isRedirect ? (
          <Redirect push to={ROUTE_PATH.LINK_TOKEN_EXPIRED.LINK}></Redirect>
        ) : (
          <ActivateStyled className="activate-page">
            <Section className="activate-wrapper">
              <Section className="notification">
                Account activated, please setup your password.
              </Section>
              <Formik
                enableReinitialize={true}
                initialValues={this.state.formDetail}
                onSubmit={this.onFormSubmit}
                validateOnBlur={false}
                validateOnChange={false}
                validationSchema={yup.object().shape({
                  password: yup
                    .string()
                    .min(8, 'minimum 8 characters')
                    .required('This field is required')
                    .matches(
                      /^(?=.*[A-Z])(?=.*\d)[A-Z\d]/,
                      'New Password should contain at least one upper case and one number character'
                    ),
                  confirmPassword: yup
                    .string()
                    .min(8, () => {
                      return 'minimum 8 characters'
                    })
                    .required('This field is required'),
                })}
              >
                {({
                  values,
                  submitForm,
                  errors,
                  setErrors,
                  setFieldValue,
                  setFieldError,
                }) => {
                  return (
                    <Form>
                      <Section className="activate-form">
                        <Input
                          id="activate_password"
                          className={
                            this.state.passwordCorrect && !errors.password
                              ? 'is-success'
                              : errors.password && 'is-error'
                          }
                          label="Password"
                          name="password"
                          type="password"
                          value={values.password}
                          onChange={e => {
                            setErrors({ ...errors, password: '' })
                            this.handleUserInput(
                              setFieldValue,
                              e,
                              setFieldError
                            )
                          }}
                          minLength={8}
                          min={8}
                          placeholder="Minimum 8 characters"
                        />
                        <Section className="mix-number-text">
                          Use 8 or more characters with a mix of numbers and at
                          least one uppercase letter
                        </Section>
                        <p className="invalid-message">{errors.password}</p>
                        <Input
                          id="reenter_password"
                          className={
                            this.state.confirmPasswordCorrect &&
                            !errors.confirmPassword
                              ? 'is-success'
                              : errors.confirmPassword && 'is-error'
                          }
                          label="Reenter password"
                          name="confirmPassword"
                          type="password"
                          value={values.confirmPassword}
                          onChange={e => {
                            setErrors({ ...errors, confirmPassword: '' })
                            this.handleUserInput(
                              setFieldValue,
                              e,
                              setFieldError
                            )
                          }}
                          minLength={8}
                          min={8}
                          placeholder="Minimum 8 characters"
                        />
                        <p className="invalid-message">
                          {errors.confirmPassword}
                        </p>

                        <Button
                          id="sign_in_button"
                          onClick={submitForm}
                          className="theme-blue"
                        >
                          Confirm
                        </Button>
                      </Section>
                    </Form>
                  )
                }}
              </Formik>
            </Section>
          </ActivateStyled>
        )}
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    login: state.login,
  }
}

export const ActivatedContainer = connect(mapStateToProps)(
  withRouter(ActivateContainer)
)
